import {
	currencyOptionsMap,
	featuresOptionsMap,
	masterUsersOptionsMap,
	officesOptionsMap,
	sitesOptionsMap,
} from "Pages/Admin/Users/@signals"

const SCALAR_FIELDS = [
	{ path: ['user', 'name'], label: 'Username' },
	{ path: ['user', 'email'], label: 'Email' },
	{ path: ['user', 'company'], label: 'Company' },
	{ path: ['user', 'defaultCurrency'], label: 'Currency', getMap: () => currencyOptionsMap.value },
	{ path: ['user', 'expirationDate'], label: 'Expiration Date' },
	{ path: ['user', 'isMaster'], label: 'Master' },
	{ path: ['userConfig', 'onlyExport'], label: 'Only Export' },
	{ path: ['userConfig', 'userTZ'], label: 'Timezone' },
	{ path: ['userConfig', 'dateFormat'], label: 'Website Date Format' },
	{ path: ['userConfig', 'dateFormatGeneration'], label: 'Generation Date Format' },
]

const ARRAY_FIELDS = [
	{ path: ['sites'], label: 'Sites', getMap: () => sitesOptionsMap.value },
	{ path: ['offices'], label: 'Offices', getMap: () => officesOptionsMap.value },
	{ path: ['masterUsers'], label: 'Master Users', getMap: () => masterUsersOptionsMap.value },
	{ path: ['user', 'extraFeatures'], label: 'Features', getMap: () => featuresOptionsMap.value },
]

function getByPath(obj, path) {
	return path.reduce((acc, key) => acc?.[key], obj)
}

function resolveLabel(value, optMap) {
	return optMap[String(value)] ?? String(value)
}

export function computeDiff(original, current) {
	if (!original || !current) return []
	const changes = []

	for (const { path, label, getMap } of SCALAR_FIELDS) {
		const oldVal = getByPath(original, path)
		const newVal = getByPath(current, path)
		if (String(oldVal ?? '') !== String(newVal ?? '')) {
			const map = getMap?.() ?? {}
			const oldDisplay = map[String(oldVal)] ?? String(oldVal ?? '—')
			const newDisplay = map[String(newVal)] ?? String(newVal ?? '—')
			changes.push({ type: 'scalar', label, oldVal: oldDisplay, newVal: newDisplay })
		}
	}

	const oldPwd = original.user?.password ?? ''
	const newPwd = current.user?.password ?? ''
	if (newPwd && newPwd !== oldPwd) {
		changes.push({ type: 'password', label: 'Password' })
	}

	for (const { path, label, getMap } of ARRAY_FIELDS) {
		const optMap = getMap()
		const oldArr = Array.isArray(getByPath(original, path)) ? getByPath(original, path) : []
		const newArr = Array.isArray(getByPath(current, path)) ? getByPath(current, path) : []
		const oldSet = new Set(oldArr.map(String))
		const newSet = new Set(newArr.map(String))
		const added = newArr.filter(v => !oldSet.has(String(v))).map(v => resolveLabel(v, optMap))
		const removed = oldArr.filter(v => !newSet.has(String(v))).map(v => resolveLabel(v, optMap))
		if (added.length > 0 || removed.length > 0) {
			changes.push({ type: 'array', label, added, removed })
		}
	}

	return changes
}
